import React from 'react';
import logoIcon from 'assets/brand/orphix_agent.svg';

// Compact mark — used in the collapsed mini-drawer.
const IconShort = () => {
  return <img src={logoIcon} alt="Orphix" style={{ height: 28, width: 28, display: 'block' }} />;
};

export default IconShort;
